import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'
import {HostMaps} from 'hiya-common/src/utils/host/AutoHost'

export enum SortTypeEnum {
  DefaultSort = 0,
  CollectSort = 1,
  CollectReverseSort = 2,
  PriceSort = 3,
  PriceReverseSort = 4,
  QuantitySort = 5,
  QuantityReverseSort = 6,
}
export enum CataLogStatusEnum {
  GiftWallStatusOffline = -1, // 礼物未上线
  GiftWallStatusUnlight = 0, // 未点亮
  GiftWallStatusCollecting = 1, // 收集中
  GiftWallStatusSuccess = 2, // 已集齐
}
export enum CataLogWearStatusEnum {
  未获得 = -1,
  已获得未穿戴 = 0,
  穿戴中 = 1,
}
export enum PageStatusEnum {
  主态 = 0,
  客态 = 1,
}

export interface GiftWallItemProps {
  gift_id: number
  gift_name: string
  gift_icon: string
  gift_cost: number // 礼物单价
  star_cnt: number // 星星数
  star_limit: number // 星星数上限
  naming_mid: number // 冠名者
  naming_avatar: string // 冠名头像
  status: CataLogStatusEnum
  gift_level: number // 礼物等级
  gift_level_icon: string // 礼物等级icon
  background: string // 礼物背景
  gift_cnt: number // 礼物数
  gift_limit: number // 礼物数上限
  base_gift_cnt: number // 每送出多少礼物可以集星
  base_star_cnt: number // 每次集多少颗星
}
export interface GiftNameplateItemProps {
  nameplate_id?: number // 身份id
  wear?: CataLogWearStatusEnum // 穿戴状态
  star_medal?: string // 身份勋章
  nameplate_bg?: string // 铭牌
  nameplate_text_map?: any // 铭牌文案
  nameplate_text_color?: Array<string> // 铭牌颜色
}

export interface InitialStateType {
  // list: Array<any>
  level: number
  medal: string
  points: number
  need_points: number
  unlocked_num: number
  obtained_num: number
  unlocked_list: Array<any>
  obtained_list: Array<any>
}

const initialState: InitialStateType = {
  level: 0,
  medal: '',
  points: 0,
  need_points: 0,
  unlocked_num: 0,
  obtained_num: 0,
  obtained_list: [],
  unlocked_list: [],
}

export const level_detail = createAsyncThunk(
  '/live/privilege/get_outfit_level_detail',
  async (arg, store: any) => {
    const resp = await http.post('/live/privilege/get_outfit_level_detail', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)

export const DressUpBookLevelSlice = createSlice({
  name: 'DressUpBookLevelSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(level_detail.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
  },
})
export default DressUpBookLevelSlice.reducer
export const DressUpBookActions = DressUpBookLevelSlice.actions

export const useDressUpBookLevelState = () => {
  const data = useSelector((state) => {
    return state.DressUpBookLevel
  })
  return data
}
